import React from 'react';
import ReactDOM from 'react-dom/client';

import { ContextProvider } from './components/store/context';

import './main.scss'
import Experience from './components/experience/experience'
import JsFile from './components/gsap/gsap';
import EasterEgg from './components/easterEgg/easterEgg';
import FooterSlider from './components/footerSlider/footerSlider'

JsFile();

if (document.getElementById('root')){
  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <ContextProvider>
      <Experience />
      <FooterSlider />
    </ContextProvider>
  );
}

// if (document.getElementById('footer__slider')){
//   const footerSlider = ReactDOM.createRoot(document.getElementById('footer__slider'));
//   footerSlider.render(
//     <ContextProvider>
//       <FooterSlider />
//     </ContextProvider>
//   );
// }

if (document.getElementById('easter-egg')){
  const easterEgg = ReactDOM.createRoot(document.getElementById('easter-egg'));
  easterEgg.render(<EasterEgg />);
}